module.exports = __webpack_public_path__ + "static/media/Icon-calendar.4517d5d1.svg";